import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useSearchParams } from 'react-router-dom'
import { ReportingQuery } from '~/QueryHooks/ReportingQuery'
import Layout from '~/components/Layout'
import { useDebounce } from 'use-lodash-debounce';
import TableComponent from '~/components/TableComponent'
import i18n from '~/components/i18n'
import { Dropdown, Input } from 'semantic-ui-react'
import { RouteTypes } from '~/routes/constants'
import { FiltersWrapper } from '../../FutureContracts/style';

const getTableColumnHeaders = () => [
  {
    name: i18n.t('Company name'),
    key: 'companyName'
  },
  {
    name: i18n.t('Supplier No.'),
    key: 'supplierNo'
  },
  {
    name: i18n.t('Total amount'),
    key: 'totalAmount',
    type: 'no-unit-number',
    decimalScale: 0
  }
]

const DetailsDelivery: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const monthParam = searchParams.get('month')
  const [search, setSearch] = useState('')
  const debouncedValue = useDebounce(search, 300);
  const [dataFiltered, setDataFiltered] = useState({
    rows: 20,
    page: 0,
    search: '',
    month: monthParam
  })

  const {
    data: districtSettings,
    isLoading: isBusySettings
  } = ReportingQuery.getDistrictDeliverySettings()

  const {
    data: districtDetailsData,
    isLoading: isBusyData,
    isFetching: isFetchingDistrictDetails,
    refetch: fetchDistrictDetails
  } = ReportingQuery.getDistrictDeliverieDetails(id, { ...dataFiltered, page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1 })

  useEffect(() => {
    fetchDistrictDetails()
  }, [dataFiltered])

  useEffect(() => {
    setDataFiltered({ ...dataFiltered, search: debouncedValue, page: 0 })
  }, [debouncedValue])

  function renderTable() {
    return <TableComponent
      tableColumnHeaders={getTableColumnHeaders()}
      animated
      isFetchingData={isFetchingDistrictDetails}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(dataFiltered) => setDataFiltered(dataFiltered)}
      rows={rows}
      total={filtered}
    />
  }

  function renderFilters() {
    return <FiltersWrapper>
      <Input
        icon={{ name: 'search', circular: true, link: true }}
        placeholder={t('Search...')}
        value={search}
        onChange={(e, data) => setSearch(data.value)}
      />
      <Dropdown
        selection
        selectOnBlur={false}
        placeholder={t('Select month')}
        value={dataFiltered.month}
        options={districtSettings?.months?.map(month => ({ value: month?.key, text: month?.label }))}
        //@ts-ignore
        onChange={(e, data) => {
          setSearchParams(`month=${data.value}`)
          //@ts-ignore
          setDataFiltered({ ...dataFiltered, month: data.value })
        }}
      />
    </FiltersWrapper>
  }

  const { filtered, rows } = districtDetailsData ? districtDetailsData : { filtered: 0, rows: [] }

  return <Layout
    title={t('Details')}
    close={RouteTypes.REPORTING_DISTRICT_DELIVERY}
    segmented
    isBusy={isBusyData || isBusySettings}
    filters={renderFilters()}
  >
    {renderTable()}
  </Layout>
}
export default DetailsDelivery